// Offline key-value cache for API data (weather, tides, forecast, route).
// Serves the last-known-good data when the device is offline.
import localforage from 'localforage';

const store = localforage.createInstance({
  name: 'boat360',
  storeName: 'offline_data',
  description: 'Cached API data for offline use',
});

// Round coordinates so nearby positions share a cache entry.
export function coordKey(prefix, lat, lon) {
  const r = (n) => Math.round(n * 20) / 20; // ~0.05 deg buckets
  return `${prefix}:${r(lat)},${r(lon)}`;
}

export async function saveOffline(key, data) {
  try {
    await store.setItem(key, { data, ts: Date.now() });
  } catch (e) {
    /* ignore quota errors */
  }
}

export async function loadOffline(key) {
  try {
    const rec = await store.getItem(key);
    if (rec && rec.data !== undefined) {
      return { data: rec.data, ts: rec.ts };
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function clearOfflineData() {
  try {
    await store.clear();
  } catch (e) {
    /* ignore */
  }
}
